import { createFileRoute } from "@tanstack/react-router";
import CityPageV2 from "@/pages/CityPageV2";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/fr/city/$city/")({
  head: ({ params }) => routeHead("/fr/city/$city/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CityPageV2 />
  );
}
